export default __webpack_public_path__ + "static/media/nodejs.30ca82b0.png";